import PageLayout from "../PageLayout";
import CustomFormPage from "../common/CustomFormPage";

export default function DynamicFormPage({
    title,
    ...rest
}) {
    return (
        <PageLayout pageTitle={title} >
            <CustomFormPage {...rest} />
        </PageLayout>
    );
};